module.exports = __webpack_public_path__ + "img/no_connect_police.1f6dccd2.png";